






























import { Component, Prop, Vue } from 'vue-property-decorator';

import firebase from "../firebase";
import { AuthUtile } from "../auth/AuthUtile";

@Component({
  components: {

  }
})
export default class ForgetYourPassword extends Vue {
  @Prop()
  isAdmin?: boolean;

  private email?: string = "";

  created() {
      console.log('created');
  }

  clickPasswordReset (){
    console.log('clickPasswordReset', this);
    // パスワード再設定 メールを送信する
    AuthUtile.sendPasswordResetEmail(firebase.auth(), this.email!, this.isAdmin!)
        .then(() =>{
            console.log('sendPasswordResetEmail');
            alert("パスワード再設定メールを送信しました");
        })
        .catch((e) =>{    
              console.error(e);
              alert("パスワード再設定メールの送信に失敗しました \n" + e.message);
          });
  }
}

